(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var UNIT = { t1: 299.99, t2: 279.99, t3: 269.99 }, SINGLE = 299.99, MAX = 10, qty = 1;

  /* ad + ClickMagick params ride along to checkout as order attributes (ad_ prefix: cmc.js rewrites bracketed utm keys) */
  var TRACK = (function () {
    var k = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'cmc_vid', 'cmc_adid', 'gc_id', 'g_special_campaign', 'h_ad_id'], q = new URLSearchParams(location.search), t = {};
    try { t = JSON.parse(sessionStorage.getItem('rv_track') || '{}'); } catch (e) {}
    k.forEach(function (n) { var v = q.get(n); if (v && v.indexOf('[') !== 0) t[n] = v.slice(0, 250); });
    try { sessionStorage.setItem('rv_track', JSON.stringify(t)); } catch (e) {}
    return t;
  })();
  function money(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function cartUrl() {
    var v = (window.RV_VARIANTS || {}).t1; if (!v) return null;
    var u = new URLSearchParams(), cm = window.clickmagick_cmc;
    u.set('attributes[ad_landing_page]', 'orbit-l6-us');
    Object.keys(TRACK).forEach(function (n) { u.set('attributes[ad_' + n + ']', TRACK[n]); });
    if (cm && cm.vid) u.set('attributes[ad_cm_visitor]', cm.vid);
    var fsu = new URLSearchParams(); fsu.set('ks_qty', String(qty || 1)); Object.keys(TRACK).forEach(function (n) { fsu.set(n, TRACK[n]); }); if (cm && cm.vid) fsu.set('cmc_vid', cm.vid); return 'https://getcosari.com/checkout-orbit-l6?' + fsu.toString();
  }
  function render() {
    var total = Math.round(SINGLE * qty * 100) / 100;
    $('[data-qty]').textContent = qty;
    $('[data-total]').textContent = money(total);
    var w = $('[data-was]'), s = $('[data-save]');
    w.hidden = s.hidden = true;
    $('[data-s-price]').textContent = money(total) + (qty > 1 ? ' · ' + qty + ' robots' : '');
    $('.step [data-step="-1"]').disabled = qty <= 1;
    $('.step [data-step="1"]').disabled = qty >= MAX;
  }
  $$('.step button').forEach(function (b) { b.addEventListener('click', function () { qty = Math.min(MAX, Math.max(1, qty + +b.getAttribute('data-step'))); render(); }); });
  function buy(e) {
    e.preventDefault(); var u = cartUrl();
    if (!u) { var t = $('[data-toast]'); t.textContent = 'Preview: checkout opens on the live store.'; t.hidden = false; setTimeout(function () { t.hidden = true; }, 2500); return; }
    location.href = u;
  }
  $('[data-buy]').addEventListener('click', buy);
  $('[data-buy2]').addEventListener('click', buy);
  var main = $('[data-main]');
  $$('.thumbs button').forEach(function (b) {
    b.addEventListener('click', function () { main.src = b.getAttribute('data-src'); $$('.thumbs button').forEach(function (x) { x.classList.toggle('on', x === b); }); });
  });
  /* sticky Add to cart once the buy box is scrolled past */
  var st = $('[data-sticky]'), atc = $('[data-buy]');
  if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (x) { st.classList.toggle('show', !x.isIntersecting && x.boundingClientRect.top < 0); }); }).observe(atc);
  render();
})();
